module.exports = __webpack_public_path__ + "static/scandi-vie-2fb28da2a7ec370f6af2cb79f479a080.jpg";